"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var transperentizeColor_1 = tslib_1.__importDefault(require("./utils/transperentizeColor"));
exports.transperentizeColor = transperentizeColor_1.default;
var theme_service_1 = tslib_1.__importStar(require("./theme-service"));
exports.DEFAULT_THEME_CONFIG = theme_service_1.DEFAULT_THEME_CONFIG;
exports.default = theme_service_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/playable/dist/src/modules/ui/core/theme/index.js
// module id = 14
// module chunks = 0